import type { Theme } from '@mui/material/styles';

const DataGrid = (theme: Theme) => {
  return {
    MuiDataGrid: {
      styleOverrides: {
        cell: {
          borderBottom: `1px solid ${theme.palette.divider}`,
        },
        columnSeparator: {
          color: theme.palette.divider,
        },
        filterForm: {
          '& .MuiFormControl-root': {
            margin: theme.spacing(0, 0.5),
          },
          '& .MuiInput-root': {
            '&::before, &::after': {
              display: 'none',
            },
            '& .MuiNativeSelect-select, .MuiInput-input': {
              ...theme.typography.body2,
              backgroundColor: theme.palette.background.neutral,
              borderRadius: theme.shape.borderRadius,
              padding: theme.spacing(0.75, 1),
            },
            '& .MuiSvgIcon-root': {
              right: 4,
            },
            marginTop: theme.spacing(3),
          },
          padding: theme.spacing(1.5, 0),
        },
        menu: {
          '& .MuiMenuItem-root': {
            ...theme.typography.body2,
            '& .MuiListItemIcon-root': {
              minWidth: 'auto',
            },
          },
          '& .MuiPaper-root': {
            boxShadow: theme.customShadows.dropdown,
          },
        },
        panelFooter: {
          '& .MuiButton-root': {
            '&:first-of-type': {
              '&:hover': {
                backgroundColor: theme.palette.action.hover,
              },
              color: theme.palette.text.primary,
              marginRight: theme.spacing(1.5),
            },
            '&:last-of-type': {
              '&:hover': {
                backgroundColor: theme.palette.primary.dark,
              },
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.common.white,
            },
          },
          borderTop: `1px solid ${theme.palette.divider}`,
          justifyContent: 'flex-end',
          padding: theme.spacing(2),
        },
        paper: {
          boxShadow: theme.customShadows.dropdown,
        },
        root: {
          '& .MuiTablePagination-root': {
            borderTop: 0,
          },
          border: `1px solid transparent`,
          borderRadius: 0,
        },
        toolbarContainer: {
          '& .MuiButton-root': {
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            },
            color: theme.palette.text.primary,
            marginRight: theme.spacing(1.5),
          },
          backgroundColor: theme.palette.background.neutral,
          padding: theme.spacing(2),
        },
      },
    },
  };
};

export default DataGrid;
